import { render, staticRenderFns } from "./xhsBuy.vue?vue&type=template&id=67dc1570&scoped=true&"
import script from "./xhsBuy.vue?vue&type=script&lang=js&"
export * from "./xhsBuy.vue?vue&type=script&lang=js&"
import style0 from "./xhsBuy.vue?vue&type=style&index=0&id=67dc1570&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dc1570",
  null
  
)

export default component.exports